/* istanbul ignore file */

import { Component, signal, WritableSignal, ChangeDetectionStrategy } from '@angular/core';
import { MatSlideToggle } from '@angular/material/slide-toggle';
// eslint-disable-next-line no-restricted-imports -- This debugger intentionally reads and mutates feature flag signals.
import { FeatureFlagsService } from '@libs/shared/common';

@Component({
  selector: 'ui-feature-flag-debugger',
  templateUrl: './feature-flag-debugger.component.html',
  styleUrl: './feature-flag-debugger.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    MatSlideToggle,
  ],
})
export class FeatureFlagDebuggerComponent {
  public flags: WritableSignal<string[]> = signal([]);

  public constructor(private readonly featureFlagService: FeatureFlagsService) {
    this.flags.set(Object.keys(featureFlagService).filter(x => x.startsWith('_')));
  }

  public setFlag(key: string, value: boolean): void {
    // @ts-expect-error its a debugger component
    (this.featureFlagService[key] as unknown as WritableSignal<boolean>).set(value);
  }

  public getFlagValue(key: string): boolean {
    // @ts-expect-error its a debugger component
    return (this.featureFlagService[key] as unknown as WritableSignal<boolean>)();
  }
}
